import fetchWithDefaults from '../../CommonUtils/fetchWithDefaults';
import { notifyPdfLoadedSection } from '../../PDFRenderer/PDFRendererActions';
import { PdfSectionType } from '../../PDFRenderer/PDFRendererTypes';

export const START_REQUEST = 'REPORT/ASSET_ALLOCATION.START_REQUEST';
export const SUCCESS_REQUEST = 'REPORT/ASSET_ALLOCATION.SUCCESS_REQUEST';
export const FAIL_REQUEST = 'REPORT/ASSET_ALLOCATION.FAIL_REQUEST';

export const TOGGLE_SHOW_DETAILED = 'REPORT/ASSET_ALLOCATION.TOGGLE_SHOW_DETAILED';

export const CLEAR_STATE = 'REPORT/ASSET_ALLOCATION.CLEAR_STATE';

export const clearState = () => ({
  type: CLEAR_STATE,
});

export const toggleDetailedPortfolio = () => ({
  type: TOGGLE_SHOW_DETAILED,
});

export const fetchTransactions = (clientId, fpId, options = {}) => async dispatch => {
  dispatch({
    type: START_REQUEST,
  });
  const data = JSON.stringify({
    clientId,
    fpId,
    ...options,
  });

  const response = await fetchWithDefaults(
    `/Consumer/AssetAllocationReport?json=${encodeURIComponent(data)}`,
  );

  if (response.ok) {
    const { success, payload, errors, errorType } = await response.json();
    if (success) {
      const { viewData } = payload;
      dispatch({
        type: SUCCESS_REQUEST,
        payload: viewData,
      });
      dispatch(notifyPdfLoadedSection(PdfSectionType.AssetAllocation));
    } else {
      dispatch({
        type: FAIL_REQUEST,
        payload: {
          errors,
          errorType,
        },
      });

      if (errorType === 'MissingAccounts') {
        // we can accept this error in PDF, it won't render anything
        dispatch(notifyPdfLoadedSection(PdfSectionType.AssetAllocation));
      }
    }
  } else {
    dispatch({
      type: FAIL_REQUEST,
    });
  }
};
